/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { OperationType } from 'relay-runtime';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type JpdBlueprintsFeedbackBannerEntryPointComponent = EntryPointComponent<
	Record<string, OperationType>,
	// oxlint-disable-next-line @typescript-eslint/no-explicit-any
	Record<string, EntryPoint<any, any> | undefined>,
	{},
	{} | null
>;

export const jpdBlueprintsFeedbackBannerEntryPoint: EntryPoint<
	JpdBlueprintsFeedbackBannerEntryPointComponent,
	{}
> = createEntryPoint({
	root: JSResourceForInteraction<JpdBlueprintsFeedbackBannerEntryPointComponent>(
		/* webpackChunkName: "async-banner-jpd-blueprints-feedback" */ './BannerJpdBlueprintsFeedbackBannerEntryPoint.tsx',
	),
	getPreloadProps: () => ({}),
});
